export const defaultDroppingFeaturesAlertProps = {
  body: 'Data for this widget is not available at this zoom level. Zoom in to get data from features in the map.'
}
